define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var BulkEditCustomerModel = /** @class */ (function () {
        function BulkEditCustomerModel(data) {
            this.AccountManagerId = ko.observable();
            this.ProjectManagerId = ko.observable();
            this.AgentId = ko.observable();
            this.BulkEditAccountManager = ko.observable();
            this.BulkEditProjectManager = ko.observable();
            this.BulkEditAgent = ko.observable();
            this.Customers = ko.observableArray();
            this.CustomersIds = ko.observableArray();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, BulkEditCustomerModel.Mapping, self);
            }
        }
        BulkEditCustomerModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new BulkEditCustomerModel(options.data);
            }
        };
        return BulkEditCustomerModel;
    }());
    return BulkEditCustomerModel;
});
//# sourceMappingURL=BulkEditCustomerModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/BulkEditCustomerModel.js
// module id = 163
// module chunks = 2